import { getDateOfToday, NoDataComponent } from '@repo/ui';
import ptBr from 'apexcharts/dist/locales/pt-br.json';
import { GetProfessionalOverviewUseCaseInterface } from 'domain/usecases';
import ApexChart from 'react-apexcharts';

interface IProps {
  data?: GetProfessionalOverviewUseCaseInterface.Result['validatedActivitiesOnMonth']['series'];
}

export const ProfessionalActivitiesQtyPerDayChart = ({ data }: IProps) => {
  if (!data || data?.length === 0) {
    return <NoDataComponent />;
  }

  // Constants
  const chartOptions = {
    chart: {
      locales: [ptBr],
      defaultLocale: 'pt-br',
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: 'straight',
      width: 2,
    },
    colors: ['#00E396'],
    markers: {
      size: 4,
    },
    xaxis: {
      type: 'datetime',
      labels: {
        datetimeFormatter: {
          year: 'yyyy',
          month: 'dd MMM',
          day: 'dd MMM',
          hour: 'HH:mm',
        },
      },
    },
  };

  const today = getDateOfToday();

  const professionalActivitiesQtyPerDay = data.map((item, idx) => {
    return {
      x: new Date(today).setDate(today.getDate() - (data.length - 1 - idx)),
      y: item,
    };
  });

  const chartSeries = [
    {
      name: 'Atividades',
      data: professionalActivitiesQtyPerDay,
    },
  ];

  return (
    <ApexChart
      type="line"
      options={chartOptions}
      height={300}
      series={chartSeries}
    />
  );
};
